
  import { Vue, Component, Prop } from "vue-property-decorator";
  import { Project_Activity, Project_Activity_Request_More_Hours } from "@/generated/graphql";
  import { Project } from "@/interface";
  import ActivityItem from "@/components/projects/activities/ActivityItemNew.vue";
  import CardBodyItem from "@/components/card/CardBodyItem.vue";
  import { NOTIFICATION } from "@/entities/Events";
  import { defaultErrorMessage } from "@/data/errorMessages";
  import UPDATE_PROJECT_ACTIVITY from "@/apollo/projectActivities/UpdateActivity.gql";
  import Message from "@/data/notificationsMessages";
  import CardForm from "@/components/card/CardForm.vue";
  import ContractorReport from "@/components/projects/activities/ContractorReport.vue";
  import CardLabel from "@/data/cardLabels";
  import addDollarSign from "@/helpers/addDollarSign";
  // import RequestMoreHoursModal from "@/components/projects/timeTracker/RequestMoreHoursModal.vue";
  import convertSecondsToReadable from "@/utils/convertSecondsToReadable";
  import PROJECT_ACTIVITY_APPROVED_TIMES_SUM from "@/apollo/projectActivities/GetProjectActivityApprovedTimesSum.gql";
import PROJECT_ACTIVITY_CREATED_REQUEST_MORE_HOURS_AGGREGATE from "@/apollo/projectActivities/ProjectActivityCreatedRequestMoreHours.gql";

  @Component({
    components: {
      ContractorReport,
      CardForm,
      CardBodyItem,
      ActivityItem,
      // RequestMoreHoursModal,
    },
    apollo: {
      approvedTimesSum: {
        query: PROJECT_ACTIVITY_APPROVED_TIMES_SUM,
        variables() {
          return {
            id: this.activity?.id
          }
        },
        update: (data) => data.project_activity_time_aggregate.aggregate.sum.time,
      },
      moreHoursRequest: {
        query: PROJECT_ACTIVITY_CREATED_REQUEST_MORE_HOURS_AGGREGATE,
      variables() {
        return {
          activityId: this.activity?.id,
        };
      },
      update: (data) => data.project_activity_request_more_hours_aggregate.aggregate.sum.hours,
      },
    }
  })
  export default class ContractorActivityCard extends Vue {
    @Prop({ type: Object, required: true }) readonly activity!: Project_Activity;
    @Prop({ type: Object, required: true }) readonly project!: Project;
    @Prop({ type: Boolean, default: false }) readonly redirectToContractor!: object;
    @Prop({ type: Boolean, default: false }) readonly frozen!: boolean;
    @Prop({ type: String, required: true }) readonly currentUserId!: string;
    @Prop({ type: String, default: undefined }) readonly companyId?: string;

    processing: boolean = false;
    finalHoursText: string = CardLabel.FinalHours;
    finalCostText: string = CardLabel.FinalCost;
    showRequestMoreHoursModal: boolean = false;
    convertSecondsToReadable = convertSecondsToReadable;
    approvedTimesSum: number = 0;
    moreHoursRequest: number = 0;

    async refetchMoreHoursRequest(): Promise<void> {
      await this.$apollo.queries.moreHoursRequest.refetch();
    }

    get finalHours(): number | null | undefined {
      return this.activity.final_hours;
    }

    get finalCostContent(): string {
      return addDollarSign(this.finalCost);
    }

    get finalCost(): number | null | undefined {
      return this.activity.final_cost;
    }

    get reportReceived(): boolean {
      return this.activity.final_report_confirmed;
    }

    get finalHoursInfoShown(): boolean {
      return this.isReportEdited(this.finalHours) && this.reportReceived;
    }

    get finalCostInfoShown(): boolean {
      return this.isReportEdited(this.finalCost) && this.reportReceived;
    }

    get finalReportShown(): boolean {
      //@ts-ignore
      const hoursConfirmed = this.activity.confirmed_hours > 0;
      const reportConfirmed = this.activity.final_report_confirmed
      return this.activity.completed && hoursConfirmed && !reportConfirmed;
    }

    get canEditRequestedHours(): boolean {
      return !this.activity.completed && !this.activity.confirmed_hours;
    }

    async updateRequestedHours(hours: number): Promise<void> {
      if (this.processing) {
        return;
      }

      this.processing = true;

      try {
        await this.$apollo.mutate({
          mutation: UPDATE_PROJECT_ACTIVITY,
          variables: {
            id: this.activity.id,
            set: {
              requested_hours: hours,
            },
          },
        });

        this.$eventBus.emit(
          NOTIFICATION,
          Message.successMessage(`The estimated hours amount was successfully updated`)
        );
      } catch (_) {
        this.$eventBus.emit(NOTIFICATION, Message.errorMessage(defaultErrorMessage));
      } finally {
        this.processing = false;
      }
    }

    isReportEdited(amount: number | null | undefined): boolean {
      return typeof amount === "number";
    }
  }
